var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.6667C12.3636 10.6667 9.25818 12.9285 8 16.1212C9.25818 19.3139 12.3636 21.5758 16 21.5758C19.6364 21.5758 22.7418 19.3139 24 16.1212C22.7418 12.9285 19.6364 10.6667 16 10.6667ZM16 19.7576C13.9927 19.7576 12.3636 18.1285 12.3636 16.1212C12.3636 14.1139 13.9927 12.4849 16 12.4849C18.0073 12.4849 19.6364 14.1139 19.6364 16.1212C19.6364 18.1285 18.0073 19.7576 16 19.7576ZM16 13.9394C14.7927 13.9394 13.8182 14.9139 13.8182 16.1212C13.8182 17.3285 14.7927 18.303 16 18.303C17.2073 18.303 18.1818 17.3285 18.1818 16.1212C18.1818 14.9139 17.2073 13.9394 16 13.9394Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.be7f77fcb7c27ace56a617b7d257700d.svg";
export { ForwardRef as ReactComponent };